import React from 'react';
import { NumberInput } from '../../form/NumberInput';
import { FieldErrors } from '../../form/FieldErrors';
import { RecordSelectInput } from '../../form/RecordSelectInput';
import { DateInput } from '../../form/DateInput';
import * as Grid from '../../components/Grid';
import { Button } from '../../components/Button';
import { BrokerFields } from './BrokerFields';
export const CoreQuoteFields = (props) => {
    const { order, brokerInfo, states, onChange, activities, errors } = props;
    const [showBrokerDetails, setShowBrokerDetails] = React.useState(order.broker_attributes?.id ? true : false);
    React.useEffect(() => {
        if (!showBrokerDetails && order.broker_attributes?.id) {
            setShowBrokerDetails(true);
        }
    }, [order.broker_attributes?.id]);
    const onEventChange = (n, v) => {
        onChange({
            ...order,
            event_attributes: {
                ...order.event_attributes,
                [n]: v,
            },
        });
    };
    const onOrderChange = (n, v) => {
        onChange({
            ...order,
            [n]: v,
        });
    };
    const onShowBrokerDetails = () => {
        setShowBrokerDetails(true);
    };
    return (React.createElement("fieldset", null,
        React.createElement("h2", null, "Quote"),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 12 },
                React.createElement(RecordSelectInput, { label: "Event Location (state event will be held in)", id: "state_id", value: order.state_id, options: states, errors: errors, onChange: (v) => onOrderChange('state_id', v) }))),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 12, lg: 6 },
                React.createElement(RecordSelectInput, { label: "Activity", id: "activity_id", value: order.activity_id, options: activities, onChange: (v) => onOrderChange('activity_id', v) })),
            React.createElement(Grid.Column, { width: 12, lg: 6 },
                React.createElement(NumberInput, { label: "Estimated Attendance Per Day", id: "daily_attendance", errors: errors, required: true, value: order.event_attributes?.daily_attendance, onChange: (v) => onEventChange('daily_attendance', v) }))),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 6 },
                React.createElement(DateInput, { label: "Start Date", id: "start_date", required: true, errors: errors, value: order.event_attributes?.start_date, minDate: new Date(), onChange: (v) => onEventChange('start_date', v) }),
                React.createElement(FieldErrors, { name: "event_start_date", errors: errors })),
            React.createElement(Grid.Column, { width: 6 },
                React.createElement(DateInput, { label: "End Date", id: "end_date", required: true, errors: errors, value: order.event_attributes?.end_date, minDate: new Date(), onChange: (v) => onEventChange('end_date', v) }),
                React.createElement(FieldErrors, { name: "event_end_date", errors: errors }))),
        !showBrokerDetails && !brokerInfo && (React.createElement(Button, { className: "button--full", onClick: onShowBrokerDetails }, "Click here if you are a broker/agent or working with an agency")),
        (showBrokerDetails || brokerInfo) && (React.createElement(React.Fragment, null,
            React.createElement(BrokerFields, { onChange: (b) => onChange({ ...order, broker_attributes: b }), errors: errors, states: states, broker: order.broker_attributes || {} }),
            !brokerInfo && (React.createElement(Button, { className: "button--full", onClick: () => {
                    onChange({ ...order, broker_attributes: {} });
                    setShowBrokerDetails(false);
                } }, "Click here if you are neither a broker/agent nor working with an agency"))))));
};
